var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"open-on-click":"","open-on-hover":false,"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',{attrs:{"retain-focus-on-click":""},on:{"click":function($event){return _vm.copyText(on, $event)},"blur":on.blur}},[_vm._v("mdi mdi-content-copy")])]}}])},[_vm._v(" Gekopieerd naar klembord! ")])}
var staticRenderFns = []

export { render, staticRenderFns }